import parse from 'html-react-parser';

import { Box, Link } from '@bcp-nextgen-dx-component-factory/design-system';
import { NavRight } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';

import { AppComposableTypography } from '../_cf';
import { ImageWithBackground } from '../imageWithBackground';
import { BannerContent, DEFAULT_BANNER_BACKGROUND, PRIMARY_DARK_COLOR_TOKEN, useBannerHelper } from './banner.helper';

export const BannerDesktop = () => {
	const { background, LogoIcon, contents } = useBannerHelper();

	return (
		<Box
			styles={{
				position: 'relative',
				flexDirection: 'column',
				padding: UIHelper.rem(120, 96, 48),
				alignItems: 'end',
				maxHeight: '100vh',
				overflow: 'hidden',
			}}
		>
			<ImageWithBackground imageSrc={background.desktop} background={DEFAULT_BANNER_BACKGROUND} />

			<Box
				styles={{
					flex: 1,
					flexDirection: 'column',
					width: '100%',
					maxWidth: UIHelper.rem(462),
				}}
			>
				<Box styles={{ marginBottom: UIHelper.rem(64) }}>
					<LogoIcon width={169} height={51} />
				</Box>

				{contents.map((content, index) => (
					<Content key={index} content={content} />
				))}
			</Box>
		</Box>
	);
};

const Content = ({ content }: { content?: BannerContent }) => {
	const { text, leftIcon, link, margin, icon } = content || {};

	const boxStyles = { alignSelf: 'start', gap: '8px', margin };

	if (text) {
		return (
			<Box styles={boxStyles}>
				{!!leftIcon && <Box>{parse(leftIcon)}</Box>}
				<AppComposableTypography colorToken={PRIMARY_DARK_COLOR_TOKEN} text={text} />
			</Box>
		);
	}

	if (link?.text && link.url) {
		return (
			<Box styles={boxStyles}>
				<Link
					target="_blank"
					variant="secondary"
					surface="onInverse"
					size="large"
					link={link.url}
					label={link.text}
					rightIcon={() => <NavRight.Outline fill="#fff" />}
				/>
			</Box>
		);
	}

	if (icon) {
		return <Box styles={boxStyles}>{parse(icon)}</Box>;
	}

	return null;
};
